"use strict";

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass.js").default;
var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IpcService = exports.defaultOptions = void 0;
var uuid_1 = require("shared/utils/uuid");
var IpcChannel_1 = require("./IpcChannel");
exports.defaultOptions = {
  timeout: 5000
};
var IpcService = /*#__PURE__*/_createClass(function IpcService() {
  var _this = this;
  _classCallCheck(this, IpcService);
  this.channelsOpened = {};
  this.request = function (channel, data, options) {
    var request = {
      payload: data,
      uuid: (0, uuid_1.uuidv4)(),
      channel: channel
    };
    var timeout = options && options.timeout || exports.defaultOptions.timeout;
    return new Promise(function (resolve, reject) {
      var callback = function callback(event, response) {
        if (!response || response.uuid !== request.uuid) {
          return;
        }
        // We are handling the exchange this callback is meant for
        _this.removeAllListeners((0, IpcChannel_1.getAck)(channel));
        clearTimeout(_this.channelsOpened[channel].timer);
        delete _this.channelsOpened[channel];
        response.error ? reject(response.error) : resolve(response.payload);
      };
      if (_this.channelsOpened[channel]) {
        clearTimeout(_this.channelsOpened[channel].timer);
        _this.channelsOpened[channel].timer = undefined;
        _this.removeAllListeners((0, IpcChannel_1.getAck)(channel));
      }
      _this.listen((0, IpcChannel_1.getAck)(channel), callback);
      _this.send(channel, request);
      _this.channelsOpened[channel] = {
        timer: setTimeout(function () {
          clearTimeout(_this.channelsOpened[channel].timer);
          reject(new Error("Request ".concat(channel, " ").concat(request.uuid, " timed out after ").concat(timeout, "ms")));
        }, timeout)
      };
    });
  };
  this.on = function (channel, callback) {
    _this.listen(channel, function (event, request) {
      callback(request.payload).then(function (data) {
        var response = Object.assign(Object.assign({}, request), {
          payload: data
        });
        _this.send((0, IpcChannel_1.getAck)(channel), response);
      }).catch(function (error) {
        _this.send((0, IpcChannel_1.getAck)(channel), Object.assign(Object.assign({}, request), {
          error: "".concat(error)
        }));
      });
    });
  };
});
exports.IpcService = IpcService;